import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://madinatalilm-12-default-rtdb.firebaseio.com/'
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios-orders.js